import { createRouter, createWebHistory } from "vue-router";

// Layout
import MainLayout from "@/layouts/MainLayout.vue";

// Vistas públicas
import LoginView from "@/layouts/LoginView.vue";

// Lazy-load vistas internas
const Empresas = () => import("@/components/EmpresasView.vue");
const Usuarios = () => import("@/components/UsuariosView.vue");
const HorariosView = () => import("@/components/HorariosView.vue");
const MesasView = () => import("@/components/MesasView.vue");
const RubrosView = () => import("@/components/RubrosView.vue");
const UPerfilempresaView = () => import("@/components/UPerfilempresaView.vue");
const OfertademandaView = () => import("@/components/OfertasdemandaView.vue");
const UReunionesView = () => import("@/components/UReunionesView.vue");
const UAgendaView = () => import("@/components/UAgendaView.vue");
const UParticipantesView = () => import("@/components/UParticipantesView.vue");
const UHorariosView = () => import("@/components/UHorariosView.vue");
const eventosView = () => import("@/components/EventosView.vue");
const evaluacionview = () => import("@/components/EvaluacionView.vue");

const routes = [
  {
    path: "/",
    name: "Login",
    component: LoginView,
  },
  {
    path: "/registro",
    name: "Registro",
    component: LoginView,
    props: { abrirRegistro: true },
  },
  {
    path: "/",
    component: MainLayout,
    children: [
      { path: "empresas", name: "Empresas", component: Empresas },
      { path: "usuarios", name: "Usuarios", component: Usuarios },
      { path: "horarios", name: "Horarios", component: HorariosView },
      { path: "mesas", name: "Mesas", component: MesasView },
      { path: "rubros", name: "Rubros", component: RubrosView },
      {
        path: "perfilempresa",
        name: "PerfilEmpresa",
        component: UPerfilempresaView,
      },
      {
        path: "ofertasdemanda",
        name: "OfertasDemanda",
        component: OfertademandaView,
      },
      { path: "reuniones", name: "Reuniones", component: UReunionesView },
      { path: "agenda", name: "Agenda", component: UAgendaView },
      {
        path: "participantes",
        name: "Participantes",
        component: UParticipantesView,
      },
      { path: "uhorarios", name: "HorariosUsuario", component: UHorariosView },
      { path: "/eventos", name: "EventosView", component: eventosView },
      {
        path: "/evaluacion",
        name: "EvaluacionView",
        component: evaluacionview,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
